export default __webpack_public_path__ + "static/media/2hazy.f941314b.png";